import React from "react"
import { cn } from "../utils"

export type CommandKbdProps = React.ComponentPropsWithoutRef<"kbd">

/**
 * A single key rendered in a small gray box. The shared building block for
 * keyboard affordances — used on its own (e.g. an `↵` in `Command.Hint`) or
 * grouped by `Command.Shortcut` for a chord.
 */
export function CommandKbd({ className, children, ...props }: CommandKbdProps) {
  return (
    <kbd
      className={cn(
        "font-sans flex shrink-0 items-center justify-center rounded-[4px] bg-gray-900/[0.06] p-1 min-w-5 text-xs font-semibold leading-3 text-gray-900 uppercase",
        className
      )}
      {...props}
    >
      <span>{children}</span>
    </kbd>
  )
}

CommandKbd.displayName = "Command.Kbd"
